export const mapboxToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN as string;
export const mapboxStyle = process.env.REACT_APP_MAPBOX_STYLE as string;
